import io from 'socket.io-client'
import configs from '../configs'
import Notify from 'quasar/src/plugins/Notify.js';

const socket = io(configs.SOCKET_IP, {
  transport: ['websocket'],
  autoConnect: false,
  reconnection: true,
  secure: true,
  rejectUnauthorized: false,
  path: '/support/socket.io'
})

socket.on('connect', () => {
  console.log('Conectado Socket.IO')
})

socket.on('notification', (data) => {
  if (!window.location.href.includes('support')) {
    Notify.create({
      message: `[ Chat Suporte ] Disse: ${data.text} <br><strong class="text-italic">Para responder clique em suporte!</strong>`,
      html: true,
      timeout: 20000,
      icon: 'fas fa-comment-dots',
      color: 'info',
      position: 'top-right'
    })
  }
})

socket.on('close', (data) => {
  if (!window.location.href.includes('support')) {
    Notify.create({
      message: `[ Chat Suporte ] Disse: ${data.text} <br><strong class="text-italic">Para ver detalhes clique em suporte!</strong>`,
      html: true,
      timeout: 20000,
      icon: 'fas fa-comment-dots',
      color: 'info',
      position: 'top-right'
    })
  }
})

socket.on('disconnect', () => {
  console.log('Desconectado Socket.IO')
})

export default {
  install (Vue, options) {
    Vue.prototype.$socket = socket
  },
  socket
}
